<template>
    <swiper :options="swiperOptions" ref="cellListSwiper" :class="'swiper ' + thumbnailInfo.componentName">
      <swiper-slide v-for="(cell, index) in cellList" :key="index">
        <div @click.prevent="clickCell(cell)">
          <component :is="component" :cell-info="cell"></component>
        </div>
      </swiper-slide>
      <div class="swiper-button-prev" slot="button-prev"></div>
      <div class="swiper-button-next" slot="button-next"></div>
    </swiper>
</template>
<script>
  import _ from 'lodash'
  import { swiper, swiperSlide } from 'vue-awesome-swiper'
  import BaseballLandscapeCell from '@/components/model/cell/BaseballLandscapeCell'
  import constant from '@/common/resources/constant'
  import { alarmClick } from '@/common/utils/baseball'
  import cookie from '@/common/utils/cookie'
  export default {
    name: 'BaseballScheduleCellList',
    components: {
      swiper,
      swiperSlide,
      BaseballLandscapeCell
    },
    props: {
      cellList: {
        type: Array
      },
      cellType: {
        type: String
      },
      thumbnailInfo: {
        type: Object
      }
    },
    data () {
      return {
        component: null,
        timer: null,
        swiperOptions: {
          width: 1240,
          height: this.thumbnailInfo.height,
          paginationClickable: true,
          spaceBetween: 10,
          slidesPerView: 5,
          slidesPerGroup: 5,
          pagination: '.swiper-pagination',
          nextButton: '.swiper-button-next',
          prevButton: '.swiper-button-prev'
        }
      }
    },
    methods: {
     async clickCell (cell) {
       const gameStatus = _.get(cell, 'game_status', 'PREV')
       switch (gameStatus) {
         case 'END' :
           if (_.get(cell, 'record_yn', 'N').toUpperCase() === 'Y') {
             this.$router.push(`/baseball/result?game_id=${_.get(cell, 'game_id', '')}`)
           } else {
             alert(constant.MSG_GAME_END)
           }
           break
         case 'CANCEL':
           alert(constant.MSG_GAME_CANCEL)
           break
         case 'LIVE':
           const { name } = window.uaInfo.getBrowser()
           if (name === 'IE') {
             alert('지원되지 않는 브라우저를 사용하고 계시네요.\nIE edge, Chrome, Safari 및 Firefox로 이용해 주세요.')
           } else {
             const serviceId = _.get(cell, 'svc_id', '')
             const alarmOn = _.get(cell, 'alarm_on', 'N').toUpperCase()
             if (serviceId === '' && alarmOn === 'N') {
               alert(constant.MSG_DO_NOT_SUPPORT_LIVE_BROADCAST)
             } else {
               this.$router.push({
                 name: 'player_baseball_live',
                 query: {
                   game_id: _.get(cell, 'game_id', '')
                 }
               })
             }
           }
           break
         case 'PREV':
           if (cookie.isWavveOn()) {
            alert('웨이브온에서는 시청 예약 기능을 지원하지 않습니다.')
            return
           }
           await alarmClick(cell, this.cellList)
           this.$events.$emit('baseball-alarm')
           break
         case 'SUSPENDED':
           alert(constant.MSG_GAME_SUSPENDED)
           break
       }
     }
    },
    computed: {
      swiper () {
        return this.$refs.cellListSwiper.swiper
      }
    },
    created () {
      this.component = this.thumbnailInfo.componentName
    },
    beforeDestroy () {
      this.$refs.cellListSwiper.$destroy()
    }
  }
</script>
<style scoped>
  .swiper-pagination,
  .swiper-button-prev,
  .swiper-button-next {
    will-change: transform;
    transform: translateZ(0);
  }
</style>
